import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1694.17647 L1920,1807.11765 L0,1807.11765 L0,1694.17647 L1920,1694.17647 Z M1750.58824,113 C1843.99059,113 1920,189.009412 1920,282.411765 L1920,1468.29412 L1807.05882,1468.29412 L1807.05882,282.411765 C1807.05882,251.352941 1781.64706,225.941176 1750.58824,225.941176 L169.411765,225.941176 C138.352941,225.941176 112.941176,251.352941 112.941176,282.411765 L112.941176,1468.29412 L0,1468.29412 L0,282.411765 C0,189.009412 76.0094118,113 169.411765,113 L1750.58824,113 Z M1016.47059,564.764706 L1016.47059,1219.03294 L1258.84235,976.548235 L1338.80471,1056.51059 L960,1435.20235 L581.195294,1056.51059 L661.157647,976.548235 L903.529412,1219.03294 L903.529412,564.764706 L1016.47059,564.764706 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCollapseLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCollapseLine, _Component);

  var _super = _createSuper(IconCollapseLine);

  function IconCollapseLine() {
    _classCallCheck(this, IconCollapseLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCollapseLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCollapse",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCollapseLine.displayName = "IconCollapseLine";
  return IconCollapseLine;
}(Component);

IconCollapseLine.glyphName = 'collapse';
IconCollapseLine.variant = 'Line';
IconCollapseLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCollapseLine;
export { IconCollapseLine };